import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// axios 기본 URL·인증 인터셉터 등록 (App 렌더링 전에 반드시 먼저 실행되어야 함)
import './api';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
